
<div class="overlay" *ngIf="!displayFlag">
  <div class="overlay__inner">
      <div class="overlay__content"><div class="loader"></div></div>
  </div>
</div>

<div *ngIf="displayFlag">

<app-header></app-header>
<div class="flex-container">
  <div class="header-spacer"> </div>
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>

</div>